module.exports = __webpack_public_path__ + "static/media/noValidImageFound.aa779ebf.jpeg";